import React from 'react';

import {
    FILTER_TYPE_AUTOCOMPLETE,
    FILTER_TYPE_BOOLEAN,
    FILTER_TYPE_CHECKLIST,
    FILTER_TYPE_SELECT,
    FILTER_TYPE_TEXT,
} from '#/utils';
import { AutoCompleteInput, BooleanFilter, FilterDropdown, KeywordSearchInput, SelectableFilterDropdown } from '.';

const FilterRenderer = ({ filter, queryParams, onChange, setQueryParams, showActive = false, addCompany }) => {
    const {
        name,
        label,
        type,
        placeholder,
        options,
        tooltip,
        list_search,
        listSearch,
        isMulti,
        isMultiBoolean,
        searchIcon,
        fetchUrl,
    } = filter || {};

    const value = queryParams[name] || [];

    switch (type) {
        case FILTER_TYPE_TEXT:
            return (
                <KeywordSearchInput
                    label={label}
                    placeholder={placeholder}
                    value={value || ''}
                    setSearch={setQueryParams}
                    queryKey={name}
                    searchIcon={searchIcon}
                    list_search={list_search}
                    tooltip={tooltip}
                />
            );

        case FILTER_TYPE_SELECT:
            if (isMultiBoolean && Array.isArray(options)) {
                return (
                    <div className='flex flex-col gap-3'>
                        {options.map(option => {
                            const optionValue = queryParams[option.name] || false;
                            return (
                                <BooleanFilter
                                    key={option.name}
                                    label={option.label}
                                    value={optionValue}
                                    setSearch={setQueryParams}
                                    queryKey={option.name}
                                    tooltip={option.tooltip}
                                />
                            );
                        })}
                    </div>
                );
            }

            return (
                <SelectableFilterDropdown
                    name={name}
                    label={label}
                    options={options}
                    selected={value}
                    setSelected={onChange}
                    tooltip={tooltip}
                    listSearch={list_search}
                    isMulti={isMulti}
                    isMultiBoolean={isMultiBoolean}
                />
            );

        case FILTER_TYPE_CHECKLIST:
            return (
                <FilterDropdown
                    label={label}
                    options={options}
                    selected={value}
                    setSelected={onChange}
                    tooltip={tooltip}
                    list_search={list_search}
                    isMulti={isMulti}
                    setQueryParams={setQueryParams}
                    queryParams={queryParams}
                    showActive={showActive}
                />
            );

        case FILTER_TYPE_AUTOCOMPLETE:
            return (
                <AutoCompleteInput
                    label={label}
                    placeholder={placeholder}
                    value={value || ''}
                    setSearch={setQueryParams}
                    queryKey={name}
                    searchIcon={searchIcon}
                    tooltip={tooltip}
                    listSearch={listSearch}
                    fetch_url={fetchUrl}
                    addCompany={addCompany}
                />
            );
        case FILTER_TYPE_BOOLEAN:
            return (
                <BooleanFilter
                    label={label}
                    placeholder={placeholder}
                    value={value || false}
                    setSearch={setQueryParams}
                    queryKey={name}
                    searchIcon={searchIcon}
                    tooltip={tooltip}
                    listSearch={listSearch}
                    fetch_url={fetchUrl}
                />
            );

        default:
            return null;
    }
};

export { FilterRenderer };
